const OurServices = [
    {id:1,services:"Visa Assistance Abroad"},
    {id:2,services:"Visa Assistance in Bali"},
    {id:3,services:"Wedding Ceremony Organizer"},
    {id:4,services:"Translation Documents"},
    {id:5,services:"Travel Insurance"},
    {id:6,services:"Other Services"}
]

export default OurServices